// the specification for the expanded enumeration are contained in
// Appendix A-1 URAR Delivery Specification v1.1.xlsx

export const UADEnums =
{
		"ADUGarage": "ADU/Garage",
		"AFrame": "A-Frame",
		"AboveGrade": "Above Grade",
		"AbsorptionRateGraph": "Absorption Rate",
		"AccessoryDwellingUnit": "Accessory Dwelling Unit",
		"AccreditedAgriculturalConsultant": "AAC",
		"AccreditedFarmManager": "AFM",
		"AccreditedMember": "AM",
		"AccreditedRuralAppraiser": "ARA",
		"AccreditedSeniorAppraiser": "ASA",
		"Acres": "Ac.",
		"Active": "Active",
		"AdjustableRate": "Adjustable Rate",
		"Adobe": "Adobe",
		"Adverse": "Adverse",
		"Age": "Age",
		"Agricultural": "Agricultural",
		"AirRights": "Air Rights",
		"Airport": "Airport",
		"Airstrip": "Airstrip",
		"AlaskaNativeCorporationLand": "Alaska Native Corporation Land",
		"Alley": "Alley",
		"Allocation": "Allocation",
		"Aluminum": "Aluminum",
		"Amenities": "Amenities",
		"AmericanMeasurementStandard": "AMS",
		"AmericanNationalStandardsInstitute": "ANSI",
		"Apartment": "Apartment",
		"Appliances": "Appliances",
		"AppraisalReport": "Uniform Residential Appraisal Report",
		"Appraiser": "Appraiser",
		"AppraiserSupervisor": "Supervisory Appraiser",
		"AppraiserTrainee": "Appraiser Trainee",
		"AreaBelowGrade": "Area Below Grade",
		"Arterial": "Arterial Street",
		"Artesian": "Artesian",
		"AsIs": "As Is",
		"Asbestos": "Asbestos",
		"Asphalt": "Asphalt",
		"AssessorRecord": "Assessor Record",
		"Assigned": "Assigned",
		"AssignmentInformation": "Assignment Information",
		"AssociateOfTheRoyalInstitutionOfCharteredSurveyors": "ARICS",
		"Attached": "Attached",
		"AttachedGarage": "Attached Garage",
		"Attorney": "Attorney",
		"Auction": "Auction",
		"Auditory": "Auditory",
		"Average": "Average",
		"Balcony": "Balcony",
		"Barn": "Barn",
		"Barrel": "Barrel",
		"Baseboard": "Baseboard",
		"Basement": "Basement",
		"BathroomCount": "Bathroom Count",
		"Bathtub": "Bathtub",
		"BatteryStorage": "Battery Storage",
		"Bay": "Bay",
		"Beach": "Beach",
		"Beams": "Beams",
		"Bedroom": "Bedroom",
		"BedroomCount": "Bedroom Count",
		"BelowGradeFive": "Level B5",
		"BelowGradeFour": "Level B4",
		"BelowGradeOne": "Level B1",
		"BelowGradeThree": "Level B3",
		"BelowGradeTwo": "Level B2",
		"Beneficial": "Beneficial",
		"BiLevel": "Bi-Level",
		"BoatLift": "Boat Lift",
		"BoatRamp": "Boat Ramp",
		"BoatSlip": "Boat Slip",
		"Boathouse": "Boathouse",
		"BodyOfWater": "Body of Water",
		"Bordering": "Bordering",
		"BorderingPropertyEncroachingOnSubjectProperty": "Bordering Property Encroaching on Subject Property",
		"BorrowerInitiated": "Borrower Initiated",
		"BottomUnit": "Bottom Unit",
		"Breakdown": "Breakdown ",
		"BreakfastRoom": "Breakfast Room",
		"Brick": "Brick",
		"BuilderOrDeveloper": "Builder or Developer",
		"Building": "Building",
		"BuildingMaintenance": "Building Maintenance",
		"BuiltIn": "Built-in",
		"BuiltInGarage": "Built-in Garage",
		"BuiltInPool": "Built-in Pool",
		"Bungalow": "Bungalow",
		"Bunkhouse": "Bunkhouse",
		"BusinessCenter": "Business Center",
		"BusyRoadway": "Busy Roadway",
		"C1": "C1",
		"C2": "C2",
		"C3": "C3",
		"C4": "C4",
		"C5": "C5",
		"C6": "C6",
		"Cabinets": "Cabinets",
		"Caged": "Caged",
		"Canal": "Canal",
		"CapeCod": "Cape Cod",
		"CaregiverServices": "Caregiver Services",
		"Carpet": "Carpet",
		"Carport": "Carport",
		"Cathedral": "Cathedral",
		"CeilingHeight": "Ceiling Height",
		"CellarDoor": "Cellar Door",
		"CementBoard": "Cement Board",
		"Centralized": "Centralized",
		"CeramicTile": "Ceramic Tile",
		"Certifications": "Certifications",
		"CertifiedGeneral": "Certified General",
		"CertifiedResidential": "Certified Residential",
		"Cesspool": "Cesspool",
		"Chalet": "Chalet",
		"Cistern": "Cistern",
		"CityStreet": "City Street",
		"CivilAirportRunwayClearZone": "Civil Airport Runway Clear Zone",
		"Clay": "Clay",
		"Client": "Client",
		"ClientImposedRestrictedMarketingTime": "Client Imposed Restricted Marketing Time",
		"ClubMembership": "Club Membership",
		"Clubhouse": "Clubhouse",
		"Coal": "Coal",
		"CoastalBarrierResourcesSystem": "Coastal Barrier Resources System",
		"Cobblestone": "Cobblestone",
		"Coffered": "Coffered",
		"Collector": "Collector Street",
		"Colonial": "Colonial",
		"Commercial": "Commercial",
		"CommercialArea": "Commercial Area",
		"CommercialBuilding": "Commercial Building",
		"CommonAreas": "Common Areas",
		"CommonCarport": "Common Carport",
		"CommunityPier": "Community Pier",
		"ComparativeUnit": "Comparative Unit",
		"Complete": "Complete",
		"Completion": "Completion",
		"Composite": "Composite",
		"Composition": "Composition",
		"ConciergeServiceCoordination": "Concierge Service Coordination",
		"Concrete": "Concrete",
		"ConcreteBlock": "Concrete Block",
		"Condition": "Condition",
		"ConditionsCovenantsRestrictions": "Property Restrictions",
		"Condominium": "Condominium",
		"CondominiumQuestionnaire": "Condominium Questionnaire",
		"CondominiumUnit": "Condominium Unit",
		"Condop": "Condop",
		"Conservation": "Conservation",
		"Construction": "Construction",
		"Container": "Container",
		"Contemporary": "Contemporary",
		"Conventional": "Conventional",
		"Cooling": "Cooling",
		"Cooperative": "Cooperative",
		"CooperativeBoard": "Cooperative Board",
		"CooperativeQuestionnaire": "Cooperative Questionnaire",
		"Copper": "Copper",
		"CostApproach": "Cost Approach",
		"CostSurvey": "Cost Survey",
		"Cottage": "Cottage",
		"Counters": "Counters",
		"CourtOrderedNonForeclosureSale": "Court Ordered Non-Foreclosure Sale",
		"Cove": "Cove",
		"Craftsman": "Craftsman",
		"CrawlSpace": "Crawl Space",
		"Creek": "Creek",
		"CubicFeet": "Cu. Ft.",
		"CubicMeters": "Cu. M.",
		"CulDeSac": "Cul-de-sac",
		"DamagedAndFunctional": "Damaged and Functional",
		"DamagedAndNonfunctional": "Damaged and Nonfunctional",
		"DataAggregator": "Data Aggregator",
		"DatedSale": "DatedSale",
		"DeadEnd": "Dead End",
		"Deck": "Deck",
		"Decreasing": "Decreasing",
		"Deed": "Deed",
		"DeedInLieu": "Deed in Lieu",
		"DeedTransferOnly": "Deed Transfer Only",
		"Deeded": "Deeded Access",
		"DeepWater": "Deep Water",
		"Den": "Den",
		"DesignOrStyle": "Design or Style",
		"DesignOrStyleVariance": "Design or Style Variance",
		"DesignatedMember": "IFA",
		"DesignatedMemberAgricultural": "IFAA",
		"DesignatedMemberCounselor": "IFAC",
		"DesignatedMemberSenior": "IFAS",
		"DesktopAppraisal": "Desktop Appraisal",
		"Detached": "Detached",
		"DetachedGarage": "Detached Garage",
		"DevelopmentStandards": "Development Standards",
		"DifferentLandUse": "Different Land Use",
		"DifficultyEstimatingDepreciation": "Difficulty Estimating Depreciation",
		"DiningRoom": "Dining Room",
		"Dirt": "Dirt",
		"DisasterMitigation": "Disaster Mitigation",
		"Dock": "Dock",
		"DoorAttendant": "Door Attendant",
		"Doorways": "Doorways",
		"Drainage": "Drainage",
		"Drawn": "Drawn",
		"Drilled": "Drilled",
		"Driveway": "Driveway",
		"Drop": "Drop",
		"Dug": "Dug",
		"Dwelling": "Dwelling",
		"DwellingExterior": "Dwelling Exterior",
		"DwellingFront": "Dwelling Front",
		"DwellingRear": "Dwelling Rear",
		"EarthBerm": "Earth / Berm",
		"Easement": "Easement",
		"East": "E",
		"EconomicAgeLife": "Economic Age-Life",
		"EightFeet": "8 Ft.",
		"EightToNineFeet": "8-9 Ft.",
		"Electric": "Electric",
		"ElectricVehicleChargingStation": "EV Station",
		"ElectricalSwitches": "Electrical Switches",
		"Electricity": "Electricity",
		"Elevator": "Elevator",
		"EnclosedKennel": "Enclosed Kennel",
		"EnclosedSoffits": "Enclosed Soffits",
		"Encroachment": "Encroachment",
		"EnergyEfficientAndGreenFeatures": "Energy Efficient and Green Features",
		"EngineeredWood": "Engineered Wood",
		"EstateSale": "Estate Sale",
		"EvidenceOfErosion": "Evidence of Erosion",
		"Excellent": "Excellent",
		"ExcessLand": "Excess Land",
		"ExcessiveUnits": "Excessive Units",
		"Existing": "Existing",
		"Exterior": "Exterior",
		"ExteriorAccessOnly": "Exterior Access Only",
		"ExteriorAppraisal": "Exterior Appraisal",
		"ExteriorInspection": "Exterior Inspection",
		"ExteriorWallsAndTrim": "Exterior Walls and Trim",
		"Extraction": "Extraction",
		"FEMASpecialFloodHazardArea": "FEMA Special Flood Hazard Area",
		"FHA": "FHA",
		"FNM_FRE": "Fannie Mae | Freddie Mac",
		"Fair": "Fair",
		"FamilyRoom": "Family Room",
		"FannieMaeMHAdvantage": "Fannie Mae MH Advantage",
		"Farmhouse": "Farmhouse",
		"FeeSimple": "Fee Simple",
		"Feet": "Ft.",
		"FellowOfTheRoyalInstitutionOfCharteredSurveyors": "FRICS",
		"Fence": "Fence",
		"Fiberglass": "Fiberglass",
		"FinishedArea": "Finished Area",
		"FinishedConcrete": "Finished Concrete",
		"FireResistantDecking": "Fire Resistant Decking",
		"FireResistantExteriorWalls": "Fire Resistant Exterior Walls",
		"FireSuppressionSystem": "Fire Suppression System",
		"Fireplace": "Fireplace",
		"FirstLien": "First Lien",
		"FitnessArea": "Fitness Area",
		"FiveToSixFeet": "5-6 Ft.",
		"FiveToTenYears": "5-10 years",
		"Fixed": "Fixed",
		"Flat": "Flat",
		"FloodVents": "Flood Vents",
		"FloorPlan": "Floor Plan",
		"Flooring": "Flooring",
		"Footer": "Header and Footer",
		"ForSaleByOwner": "FSBO",
		"ForcedWarmAir": "Forced Warm Air",
		"ForeclosureSale": "Foreclosure Sale",
		"FortifiedRoof": "Fortified Roof",
		"Foundation": "Foundation",
		"FourToFiveFeet": "4-5 Ft.",
		"FourthLien": "Fourth Lien",
		"FramingAnchorageOrBracing": "Framing Anchorage or Bracing",
		"FreddieMacCHOICEHome": "Freddie Mac CHOICEHome",
		"Full": "Full",
		"FullBathroom": "Bath - Full",
		"FullyBelowGrade": "Below Grade",
		"FullyUpdated": "Fully Updated",
		"FunctionalObsolescence": "Functional Obsolescence",
		"Garage": "Garage",
		"Gas": "Gas",
		"GatedCommunity": "Gated Community",
		"Gazebo": "Gazebo",
		"GeneralAccreditedAppraiser": "GAA",
		"GeodesicDome": "Geodesic Dome",
		"Georgian": "Georgian",
		"Geothermal": "Geothermal",
		"Glass": "Glass",
		"GolfCourse": "Golf Course",
		"Good": "Good",
		"GrabBars": "Grab Bars",
		"Gravel": "Gravel",
		"GravityAir": "Gravity Air",
		"GreenSpace": "Green Space",
		"Greenhouse": "Greenhouse",
		"GrossBuildingArea": "Gross Building Area",
		"GrossLivingArea": "Finished Area",
		"GrossRentMultiplierComparableMap": "Map of GRM Comparables",
		"GroundLevel": "Ground Level",
		"GroundsMaintenance": "Grounds Maintenance",
		"GuestHouse": "Guest House",
		"Gulf": "Gulf",
		"HalfBathroom": "Bath - Half",
		"Handrails": "Handrails",
		"Hardware": "Hardware",
		"Hardwood": "Hardwood",
		"HauledWaterHoldingTank": "Hauled Water Holding Tank",
		"HawaiianHomeLands": "Hawaiian Home Lands",
		"HazardousAboveGroundStorageTank": "Hazardous Above Ground Storage Tank",
		"HazardousSubstances": "Hazardous Substances",
		"Heated": "Heated",
		"Heating": "Heating",
		"Hectares": "Ha.",
		"HighDensityResidential": "High Density Residential",
		"HighPressureGasLine": "High Pressure Gas Line",
		"HighestAndBestUse": "Highest  and Best Use",
		"Highrise": "High-rise",
		"Highway": "Highway",
		"HistoricDistrict": "Historic District",
		"HistoricPreservation": "Historic Preservation",
		"HomeEquity": "Home Equity",
		"HomeInspector": "Home Inspector",
		"HomeownersAssociation": "HOA",
		"HotelOrMotel": "Hotel / Motel",
		"House": "House",
		"HybridAppraisal": "Hybrid Appraisal",
		"Illegal": "Illegal",
		"ImpactResistantGlass": "Impact Resistant Glass",
		"ImpactResistantShingles": "Impact Resistant Shingles",
		"ImproperGrading": "Improper Grading",
		"InBalance": "In Balance",
		"Income": "Income",
		"IncomeApproach": "Income Approach",
		"Increasing": "Increasing",
		"IndependentFeeAppraiser": "Independent Fee Appraiser",
		"Individual": "Individual",
		"Indoor": "Indoor",
		"IndoorFireplace": "Indoor Fireplace",
		"IndoorRidingArena": "Indoor Riding Arena",
		"Industrial": "Industrial",
		"IndustrialArea": "Industrial Area",
		"IndustrialBuilding": "Industrial Building",
		"Inferior": "Inferior",
		"IngressOrEgress": "Ingress / Egress",
		"IngroundPool": "Inground Pool",
		"IngroundSpa": "Inground Spa",
		"Inspection": "Inspection",
		"InsufficientData": "Insufficient Data",
		"Insurable": "Insurable",
		"InsurableWithRepairEscrow": "Insurable With Repair Escrow",
		"InsuranceInspector": "Insurance Inspector",
		"InteriorAccessOnly": "Interior Access Only",
		"InteriorAndExterior": "Interior and Exterior",
		"InteriorAndExteriorAccess": "Interior and Exterior Access",
		"InteriorInspection": "Interior Inspection",
		"Investor": "Investor",
		"IrrigationSystem": "Irrigation System",
		"Kilometers": "Km.",
		"Kitchen": "Kitchen",
		"LackOfLandSales": "Lack of Land Sales",
		"Lake": "Lake",
		"LakeOrSpring": "Lake or Spring",
		"Laminate": "Laminate",
		"LandComparableMap": "Map of Land Comparables",
		"LandSale": "Land Sale",
		"LandSurvey": "Land Survey",
		"LandUse": "Land Use",
		"LandWithDwelling": "Land with Dwelling",
		"LandWithImprovement": "Land with Improvement",
		"Landfill": "Landfill",
		"Landlocked": "Landlocked",
		"Landscaping": "Landscaping",
		"LaundryRoom": "Laundry Room",
		"Leased": "Leased",
		"Leasehold": "Leasehold",
		"Legal": "Legal",
		"LegalNonConforming": "Legal Nonconforming",
		"Lender": "Lender",
		"Less": "Less",
		"LessThanOneYear": "Less than 1 year",
		"LessThanSevenFeet": "Less than 7 feet",
		"LevelEight": "Level 8",
		"LevelFive": "Level 5",
		"LevelFour": "Level 4",
		"LevelNine": "Level 9",
		"LevelOne": "Level 1",
		"LevelSeven": "Level 7",
		"LevelSix": "Level 6",
		"LevelTen": "Level 10",
		"LevelThree": "Level 3",
		"LevelTwo": "Level 2",
		"LicensedResidentialAppraiser": "Licensed Residential",
		"Lighting": "Lighting",
		"LivingArea": "Living Area",
		"LivingRoom": "Living Room",
		"LoanModification": "Loan Modification",
		"Lobby": "Lobby",
		"Local": "Local Road",
		"LocalDistributionLine": "Local Distribution Line",
		"Loft": "Loft",
		"Log": "Log",
		"LotSize": "Lot Size",
		"Low": "Low",
		"Lowrise": "Low-rise",
		"MLS": "MLS",
		"ManagementCompany": "Appraisal Management Company",
		"Manufactured": "Manufactured",
		"ManufacturedHome": "Manufactured Home",
		"ManufacturedHomeFinancingProgramEligibilityCertification": "Manufactured Home Certification",
		"ManufacturedHomeHUDCertificationLabel": "HUD Certification Label",
		"ManufacturedHomeHUDDataPlate": "HUD Data Plate",
		"Marble": "Marble",
		"Market": "Market",
		"Marsh": "Marsh",
		"Maximum": "Maximum",
		"MechanicalSystem": "Mechanical System",
		"MediaRoom": "Media Room",
		"MedianDaysOnMarketGraph": "Median Days on Market",
		"Mediterranean": "Mediterranean",
		"MemberAppraisalInstitute": "MAI",
		"MemberOfTheRoyalInstitutionOfCharteredSurveyors": "MRICS",
		"Metal": "Metal",
		"Meters": "M.",
		"Middle": "Middle",
		"MiddleUnit": "Middle Unit",
		"Midrise": "Mid-rise",
		"Miles": "Mi.",
		"MilitaryAirportAccidentPotentialZone1": "Military Airport Accident Potential Zone 1",
		"MilitaryAirportClearZone": "Military Airport Clear Zone",
		"MineralRights": "Mineral Rights",
		"MiniSplit": "Mini Split",
		"Miscellaneous": "Miscellaneous",
		"ModeratelyUpdated": "Moderately Updated",
		"Modern": "Modern",
		"ModifiedEconomicAgeLife": "Modified Economic Age-Life",
		"Modular": "Modular",
		"Most": "Most",
		"Mountain": "Mountain",
		"Mudroom": "Mudroom",
		"MultiWide": "Multi Wide",
		"MultipleZoneHeatingVentilationAndAirConditioning": "Multi-Zone HVAC",
		"NaturalGas": "Natural Gas",
		"NaturalStone": "Natural Stone",
		"NeoEclectic": "Neo-Eclectic",
		"Neutral": "Neutral",
		"NewOrLikeNew": "New or Like New",
		"NineFeet": "9 Ft.",
		"NineToTenFeet": "9-10 Ft.",
		"No": "No",
		"NoFinish": "No Finish",
		"NoInspection": "No Inspection",
		"NoPhysicalInspection": "No Physical Inspection",
		"NoWeight": "No Weight",
		"NoZoning": "No Zoning",
		"NonConformity": "Nonconformity",
		"NonNavigable": "Non-Navigable",
		"NonPublic": "Private",
		"NonResidentialUse": "Non-Residential Use",
		"NonStandardFinishedAreaAboveGrade": "Above Grade Finished Area (Nonstandard)",
		"NonStandardFinishedAreaBelowGrade": "Below Grade Finished Area (Nonstandard)",
		"NoncombustiblePerimeter": "Noncombustible Perimeter",
		"NoncontinuousArea": "Noncontinuous Area",
		"None": "None",
		"North": "N",
		"NorthEast": "NE",
		"NorthWest": "NW",
		"NotDisclosed": "Not Disclosed",
		"NotNecessaryForCredibleResults": "Not Necessary for Credible Results",
		"NotRecorded": "Not Recorded",
		"NotUpdated": "Not Updated",
		"Ocean": "Ocean",
		"OffMarket": "Off Market",
		"Office": "Office",
		"Offsite": "Offsite",
		"Oil": "Oil",
		"OilOrGasWell": "Oil or Gas Well",
		"OnFrameModular": "On-Frame Modular",
		"OneToFiveYears": "1-5 years",
		"OneToTenYears": "1-10 years",
		"OneToTwoFeet": "1-2 Ft.",
		"OngoingCleaningServices": "Ongoing Cleaning Services",
		"Onsite": "Onsite",
		"OpenLot": "Open Lot",
		"OtherParcel": "Other Parcel",
		"Outbuilding": "Outbuilding",
		"Outbuildings": "Outbuildings",
		"OutdoorAccessories": "Outdoor Accessories",
		"OutdoorFireplace": "Outdoor Fireplace",
		"OutdoorKitchen": "Outdoor Kitchen",
		"OutdoorLiving": "Outdoor Living",
		"OutdoorRidingRing": "Outdoor Riding Ring",
		"OutdoorShower": "Outdoor Shower",
		"OverSixMonths": "Over 6 months",
		"OverSupply": "Oversupply",
		"OverallQualityAndCondition": "Overall Quality and Condition",
		"Overhang": "Overhang",
		"OverheadElectricPowerTransmissionLine": "Overhead Electric Power Transmission Line",
		"Overimprovement": "Overimprovement",
		"Owned": "Owned",
		"OwnerOccupied": "Owner",
		"Park": "Park",
		"Parking": "Non-Tenant Parking",
		"ParkingGarage": "Parking Garage",
		"ParkingLot": "Parking Lot",
		"Partial": "Partial",
		"PartiallyBelowGrade": "Partially Below Grade",
		"PartiallyUpdated": "Partially Updated",
		"PassiveSolar": "Passive Solar",
		"Pastoral": "Pastoral",
		"Patio": "Patio",
		"Pavers": "Pavers",
		"PedestrianOnlyAccess": "Pedestrian Only Access",
		"Pending": "Pending",
		"PercentOfDistressedSalesGraph": "Percent of Distressed Sales",
		"PermanentGenerator": "Permanent Generator",
		"PermanentWaterfrontFeature": "Permanent Waterfront Feature",
		"Permitted": "By Permit",
		"Physical": "Physical",
		"PhysicalMeasurement": "Physical Measurement",
		"Pier": "Pier",
		"PlansAndSpecifications": "Plans and Specs",
		"PlatMap": "Plat Map",
		"Playground": "Playground",
		"Pond": "Pond",
		"PoolHouse": "Pool House",
		"Porch": "Porch",
		"PortfolioEvaluation": "Portfolio Evaluation",
		"Portico": "Portico",
		"PostAndPier": "Post and Pier",
		"PouredConcrete": "Poured Concrete",
		"PowerPurchaseAgreement": "Power Purchase Agreement",
		"PreSubdivisionSale": "Pre-Subdivision Sale",
		"Preforeclosure": "Preforeclosure",
		"PreviousAppraisalFile": "Previous Appraisal File",
		"PriceTrendGraph": "Price Trend",
		"PriorSaleAndTransferHistory": "PriorSale and Transfer History",
		"Private": "Private",
		"PrivateAirstrip": "Private Airstrip",
		"PrivateStreet": "Private Street",
		"PrivatelyOwned": "Privately Owned",
		"ProjectAmenity": "Common Amenity or Service",
		"ProjectDeficiency": "Observed Deficiency",
		"ProjectInformation": "Project Information",
		"Propane": "Propane",
		"PropertyAccess": "Property Access (Street Scene)",
		"PropertyBoundaries": "Property Boundaries",
		"PropertyDataReport": "Property Data Report",
		"PropertyManagementCompany": "Property Management Company",
		"PropertyOwner": "Property Owner",
		"PropertyTenant": "Tenant",
		"Proposed": "Proposed",
		"Proximity": "Proximity",
		"Public": "Public",
		"PublicStreet": "Public Street",
		"PublicTransportationHub": "Public Transportation Hub",
		"Purchase": "Purchase",
		"Q1": "Q1",
		"Q2": "Q2",
		"Q3": "Q3",
		"Q4": "Q4",
		"Q5": "Q5",
		"Q6": "Q6",
		"Quality": "Quality",
		"QuantitySurvey": "Quantity Survey",
		"REO": "REO",
		"REOSale": "REO Sale",
		"Radiant": "Radiant",
		"Radiators": "Radiators",
		"Radon": "Radon",
		"RadonMitigation": "Radon Mitigation",
		"RailLine": "Rail Line",
		"RaisedRanch": "Raised Ranch",
		"Rambler": "Rambler",
		"Ramps": "Ramps",
		"Ranch": "Ranch",
		"RealEstateAgent": "Real Estate Agent",
		"RealPropertyReviewAppraiser": "RPRP",
		"ReasonableExposureTime": "Reasonable Exposure Time",
		"Reconciliation": "Reconciliation",
		"RecreationArea": "Recreation Area",
		"RecreationRoom": "Recreation Room",
		"Refinance": "Refinance ",
		"RegistrationServices": "Registration Services",
		"RelocationSale": "Relocation Sale",
		"Rental": "Rental",
		"RentalComparableMap": "Map of Rental Comparables",
		"RentalInformation": "Rental Information",
		"Repair": "Repair",
		"Replacement": "Replacement ",
		"Reproduction": "Reproduction",
		"Reservoir": "Reservoir",
		"Residential": "Residential",
		"ResidentialAccreditedAppraiser": "RAA",
		"Riprap": "Riprap",
		"River": "River",
		"Road": "Road",
		"RoadFrontage": "Road Frontage",
		"Rocky": "Rocky",
		"Rolling": "Rolling",
		"Roof": "Roof",
		"RowhouseTownhouse": "Rowhouse / Townhouse",
		"Rubber": "Rubber",
		"Runner": "Runner",
		"Rural": "Rural Road",
		"Sale": "Sale",
		"SaleBetweenRelatedParties": "Sale Between Related Parties",
		"SaleOrTransferType": "Sale or Transfer Type",
		"SalePrice": "Sale Price",
		"SalesComparableMap": "Sales Comparable Map",
		"SalesComparison": "Sales Comparison",
		"SalesComparisonApproach": "Sales Comparison Approach",
		"SalesContract": "Sales Contract",
		"SanitarySewer": "Sanitary Sewer",
		"Sauna": "Sauna",
		"School": "School",
		"Seasonal": "Seasonal",
		"SeawallOrBulkhead": "Seawall or Bulkhead",
		"SecondLien": "Second Lien",
		"SemiDetached": "Semi-Detached",
		"SeniorRealPropertyAppraiser": "SRPA",
		"SeniorResidentialAppraiser": "SRA",
		"Septic": "Septic",
		"SettledSale": "Settled Sale",
		"SevenFeet": "7 Ft.",
		"SevenToEightFeet": "7-8 Ft.",
		"ShallowWater": "Shallow Water",
		"Shape": "Shape",
		"SharedDriveway": "Shared Driveway",
		"SharedLaundryFacilities": "Shared Laundry Facilities",
		"Shed": "Shed",
		"ShortSale": "Short Sale",
		"ShortTermRentalServices": "Short Term Rental Services",
		"Shortage": "Shortage",
		"Shower": "Shower",
		"SignificantRealPropertyAppraisalAssistance": "Significant Real Property Appraisal Assistance",
		"SignificantlyUpdated": "Significantly Updated",
		"Silo": "Silo",
		"Similar": "Similar",
		"SingleWide": "Single Wide",
		"Sink": "Sink",
		"Site": "Site",
		"SiteBuilt": "Site Built",
		"SiteCharacteristic": "Site Characteristic",
		"SiteExhibit": "Site Exhibit",
		"SiteInfluence": "Site Influence",
		"SixToSevenFeet": "6-7 Ft.",
		"Sketch": "Sketch",
		"Skyline": "Skyline",
		"Slab": "Slab",
		"Slate": "Slate",
		"Sloping": "Sloping",
		"SlushPit": "Slush Pit",
		"SmartHomeSystem": "Smart Home System",
		"SoilContamination": "Soil Contamination",
		"SoilSuitability": "Soil Suitability",
		"Solar": "Solar",
		"SolarShingles": "Solar Shingles",
		"Sound": "Sound",
		"South": "S",
		"SouthEast": "SE",
		"SouthWest": "SW",
		"Southwest": "Southwest",
		"Spanish": "Spanish",
		"SplitFoyerOrEntry": "Split Foyer or Entry",
		"SplitLevel": "Split Level",
		"SportsCourt": "Sports Court",
		"SquareFeet": "Sq. Ft.",
		"SquareMeters": "Sq. M.",
		"Stable": "Stable",
		"StaffAppraiser": "Staff Appraiser",
		"StandaloneADU": "Standalone ADU",
		"StandardFinishedAreaAboveGrade": "Above Grade Finished Area",
		"StandardFinishedAreaBelowGrade": "Below Grade Finished Area",
		"StandingWater": "Standing Water",
		"Steel": "Steel",
		"Stilt": "Stilt",
		"Stone": "Stone",
		"Storage": "Storage",
		"StormShelter": "Storm Shelter",
		"StormShutters": "Storm Shutters",
		"StormwaterRetention": "Stormwater Retention",
		"Stove": "Stove",
		"Stucco": "Stucco",
		"Studio": "Studio",
		"SubflooringOnly": "Subflooring Only",
		"SubjectListingInformation": "Subject Listing Information",
		"SubjectProperty": "Subject Property",
		"SubjectPropertyAmenities": "Subject Property Amenities",
		"SubjectPropertyEncroachingOnBorderingProperty": "Subject Property Encroaching on Bordering Property",
		"SubjectPropertyImprovementSketch": "Sketch",
		"SubjectToCompletionPerPlans": "Subject to Completion Per Plans",
		"SubjectToExtraordinaryAssumptions": "Subject to Extraordinary Assumptions",
		"SubjectToHypotheticalConditions": "Subject to Hypothetical Conditions",
		"SubjectToInspection": "Subject to Inspection",
		"SubjectToRepair": "Subject to Repair",
		"SumpPump": "Sump Pump",
		"Sunroom": "Sunroom",
		"SuperfundSite": "Superfund Site",
		"Superior": "Superior",
		"SupplementalExhibit": "Supplemental Exhibit",
		"SupplementalInformation": "Supplemental Information",
		"SurplusLand": "Surplus Land",
		"Synthetic": "Synthetic",
		"SyntheticStone": "Synthetic Stone",
		"SyntheticStucco": "Synthetic Stucco",
		"TarAndGravel": "Tar / Gravel",
		"TelevisionOrInternetServices": "Television or Internet Services",
		"TenFeetAndAbove": "10 or more feet",
		"TenOrMoreFeet": "10 or more feet",
		"TenOrMoreYears": "10 or more years",
		"TenToTwentyYears": "10-20 years",
		"Tenant": "Tenant",
		"ThirdLien": "Third Lien",
		"ThreeDimensionalPrintingTechnology": "3D Technology",
		"ThreeDimensionalScan": "Three-Dimensional Scan",
		"ThreeToFourFeet": "3-4 Ft.",
		"ThreeToSixMonths": "3 to 6 months",
		"TimberRights": "Timber Rights",
		"Toilet": "Toilet",
		"TopUnit": "Top Unit",
		"Topography": "Topography",
		"Traditional": "Traditional",
		"TraditionalAppraisal": "Traditional Appraisal",
		"TrafficWallBarriers": "Traffic Wall Barriers",
		"TraineeAppraiser": "Trainee Appraiser",
		"TrashRemoval": "Trash Removal",
		"Tray": "Tray",
		"TribalTrustLand": "Tribal Trust Land",
		"Tudor": "Tudor",
		"TwentyOrMoreYears": "20 or more years",
		"TwoOrMoreStories": "2 or more stories",
		"TwoToThreeFeet": "2-3 Ft.",
		"TypicalWearAndTear": "Typical Wear and Tear",
		"TypicallyMotivated": "Typically Motivated",
		"USDA": "USDA",
		"USDARuralDevelopment": "USDA",
		"USGSLavaFlowZone": "USGS Lava Flow Zone",
		"Unassigned": "Unassigned",
		"UnderConstruction": "Under Construction",
		"UnderThreeMonths": "Under 3 months",
		"UndergroundStorageTank": "Underground Storage Tank",
		"Underimprovement": "Underimprovement",
		"UnfinishedArea": "Unfinished Area",
		"UnfinishedAreaAboveGrade": "Above Grade Unfinished Area",
		"UnfinishedAreaBelowGrade": "Below Grade Unfinished Area",
		"Uninsurable": "Uninsurable",
		"Unit": "Unit",
		"UnitInPlace": "Unit In Place",
		"UnitInterior": "Unit Interior",
		"UnitStorage": "Unit Storage",
		"Units": "Units",
		"UpToOneFoot": "Up to 1 foot",
		"Utility": "Utility",
		"UtilityRoom": "Utility Room",
		"VA": "VA",
		"Vacant": "Vacant",
		"VacantLand": "Vacant Land",
		"Valley": "Valley",
		"ValueChange": "Value Change",
		"Vaulted": "Vaulted",
		"VehicleStorage": "Vehicle Storage",
		"VeryGood": "Very Good",
		"Victorian": "Victorian",
		"View": "View",
		"Vinyl": "Vinyl",
		"Virtual": "Virtual",
		"WalkInPantry": "Walk-In Pantry",
		"WalkOut": "Walk Out",
		"WalkUp": "Walk Up",
		"WallsAndCeiling": "Walls and Ceiling",
		"Water": "Water",
		"WaterAccess": "Water Access",
		"WaterContamination": "Water Contamination",
		"WaterFeatures": "Water Features",
		"WaterFrontage": "Water Frontage",
		"WaterHeater": "Water Heater",
		"WaterHeaterStrapping": "Water Heater Strapping",
		"WaterRights": "Water Rights",
		"Waterway": "Waterway",
		"Well": "Well",
		"West": "W",
		"Wetlands": "Wetlands",
		"WholeHome": "Whole Home",
		"WholeHouseVentilation": "Whole House Ventilation",
		"WholeHouseWaterTreatment": "Whole House Water Treatment",
		"Wind": "Wind",
		"WindTurbine": "Wind Turbine",
		"Windows": "Windows",
		"Wood": "Wood",
		"WoodStove": "Wood Stove",
		"Woods": "Woods",
		"Workshop": "Workshop",
		"YearBuiltOfSalesGraph": "Year Built of Sales",
		"Yes": "Yes",
		"ZeroLotLine": "Zero Lot Line",
		"Zone1": "1",
		"Zone2": "2",
		"Zone3": "3",
		"Zone4": "4",
		"Zone5": "5",
		"Zone6": "6",
		"Zone7": "7",
		"Zone8": "8",
		"Zone9": "9",
		"ZoneI": "Zone I",
		"ZoneII": "Zone II",
		"ZoneIII": "Zone III",
		"Zoning": "Zoning"
};
